// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HyCy","title":"styles_title__20Y5w"};